import HistorySection from "./HistorySection";
import { useSurgicalHistorySection } from "../hooks/use-surgical-history-section";
import {
  SURGICAL_HISTORY_LABELS,
  SURGICAL_HISTORY_NAME_LABEL,
} from "../readmission-f2f-constant";

export interface SurgicalHistorySectionProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  freeNoteValue?: string;
  onFreeNoteChange?: (value: string) => void;
}

const SurgicalHistorySection = ({
  title,
  expanded,
  onToggle,
  freeNoteValue,
  onFreeNoteChange,
}: SurgicalHistorySectionProps) => {
  const section = useSurgicalHistorySection();

  return (
    <HistorySection
      title={title}
      expanded={expanded}
      onToggle={onToggle}
      section={section}
      nameLabel={SURGICAL_HISTORY_NAME_LABEL}
      labels={SURGICAL_HISTORY_LABELS}
      freeNoteValue={freeNoteValue}
      onFreeNoteChange={onFreeNoteChange}
    />
  );
};

export default SurgicalHistorySection;
